import React, { ComponentProps } from 'react';

import { TabContext } from '@mui/lab';

export const ConditionalTabContext: React.FC<
  ComponentProps<typeof TabContext>
> = ({ value, children, ...otherProps }) => {
  if (!value) {
    return null;
  }

  return (
    <TabContext value={value} {...otherProps}>
      {children}
    </TabContext>
  );
};
